export const FunSun = 'SM';
export const Kiwi = 'KW';

/** Providers that don't lock the fare price until ticketing, so the price may change. */
export const PRICE_VOLATILE_PROVIDERS: string[] = [Kiwi];
